document.addEventListener('DOMContentLoaded', function(){
  handleChangeInputFile();
});

function handleChangeInputFile(){
  const elCustomInputFile = document.querySelectorAll('.custom-input-file input[type=file]');
  if(elCustomInputFile){
    elCustomInputFile.forEach(item=>{
      item.addEventListener('change', handleFileChange)
    })
  }
}

function handleFileChange(ev){
  const { files } = ev.target
  if(files && files.length > 0){
    const fileName = ev.target.parentElement.querySelector('.text-description');
    if(fileName)
      fileName.innerText = files[0].name;
  }
}
